import React from 'react'
import './about.css'
import OBIORA from '../../assets/about.jpeg'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'

const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className='container about__container'>
        <div className='about__me'>
           <div className='about__me-image'>
            <img src={OBIORA} alt='About Image'/>
           </div>
        </div>

        <div className='about__content'>
          <div className='about__cards'>
            <article className='about__card'>
            <FaAward className='about__icon'/>
            <h5>Experience</h5>
            <small>1+ Years Working Experience</small>
            </article>

            <article className='about__card'>
            <FiUsers className='about__icon'/>
            <h5>Clients</h5>
            <small>50+ Clients worldwide</small>
            </article>

            <article className='about__card'>
            <VscFolderLibrary className='about__icon'/>
            <h5>Projects</h5>
            <small>25+ Completed Projects</small>
            </article>
          </div>
           <p>I am a versatile software engineer with expertise in HTML, CSS, React, and JavaScript. 
           I excel at creating visually appealing front-end designs and have back-end skills in Node.js, Express.js, and TypeScript. 
           I possess strong communication and collaboration skills, am highly organized, and excel at problem-solving. 
           I prioritize tasks, meet deadlines, and continuously seek opportunities for learning and growth. Overall, 
           I bring a comprehensive skill set and a commitment to delivering exceptional web experiences through effective teamwork and strong interpersonal skills.</p>
 
    <a href='#contact' className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default About